import { Wording } from '@/types';

export const PILATES_WORDING_PL: Wording = {
  components_header_media_content: 'Treningi',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Przepisy',
  components_header_text2: 'Bloga',
  components_header_members: 'Członkowie',
  hero_text: 'Utrzymuj swoje ciało elastyczne i mocne',
  hero_button_text: 'Rozpocznij swoją przygodę z pilatesem',
  components_ressources_section_title: 'ZASOBY',
  components_ressources_subheader_text:
    'Wszystkie zasoby potrzebne do harmonijnego stylu życia',
  components_ressources_span_text:
    'Odblokuj sekrety dobrego samopoczucia: zapoznaj się z kolekcją ćwiczeń pilates i zdrowych przepisów, które pomogą Ci osiągnąć równowagę w każdym aspekcie swojego życia.',
  components_ressources_card_1_title: 'Wskazówki dotyczące pilatesu',
  components_ressources_card_1_text:
    'Praktyczne porady, które pomogą Ci pogłębić praktykę i udoskonalić swój program.',
  components_ressources_card_2_title: 'Dieta',
  components_ressources_card_2_text:
    'Inteligentne wskazówki żywieniowe, dzięki którym będziesz zdrowszy i silniejszy.',
  components_ressources_link: 'Obejrzyj filmy',
  components_notes_and_google_title_1: 'Pilates',
  components_notes_and_google_title_2: 'Regularna rutyna',
  components_notes_and_google_title_3: 'Utrzymanie diety',
  components_review_google_text: 'Recenzja w Google',
  media_content_section_title: 'TRENINGI',
  media_content_section_subheader_text: 'Nasze filmy',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Więcej filmów',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Artykuły i aktualności',
  text2_section_button_more: 'Więcej artykułów',
  components_text1_section_title: 'PRZEPISY',
  components_text1_subheader_text: 'Odżywiaj swoje ciało i umysł',
  components_text1_span_text:
    'Zdrowe przepisy wspierające Twoje ćwiczenia pilates i poprawiające samopoczucie.',
  components_text1_card_1_title: 'Energetyzujące śniadania',
  components_text1_card_1_text:
    'Obudź się dzięki żywym i dodającym energii posiłkom.',
  components_text1_card_3_title: 'Obiady pełne mocy',
  components_text1_card_3_text:
    'Odkryj pyszne i wygodne przepisy na lunch zaprojektowane z myślą o Twoim aktywnym trybie życia. Od kolorowych sałatek po pełne białka wrapy – te przepisy dodadzą Ci energii i skupią.',
  components_text1_card_2_title: 'Obiady na regenerację',
  components_text1_card_2_text:
    'Odkryj różnorodne chude białko, produkty pełnoziarniste i żywe warzywa, aby zapewnić sobie satysfakcjonujący koniec dnia.',
  components_text1_link: 'Zobacz wszystkie przepisy',
  components_footer_text:
    'Znajdź równowagę, oddychaj głęboko: Twój pilates, Twoja podróż.',
  components_footer_info: 'Informacje',
  components_footer_registration_number: 'Numer rejestracyjny',
  components_footer_legal: 'Prawny',
  components_footer_terms: 'Regulamin',
  components_footer_privacy: 'Polityka prywatności',
  button_load_more: 'Załaduj więcej',
  page_media_1_content_hero_text: 'Treningi Pilatesa',
  page_text1_hero_text: 'Przepisy',
  page_text1_section_title: 'Odżywianie',
  page_text1_subheader_text: 'Przepisy',
  page_text2_hero_text: 'Nasz blog',
  page_text2_section_title: 'Bloga',
  page_text2_subheader_text: 'Artykuły i aktualności',
  enter_email_title: 'Aby kontynuować, wprowadź swój adres e-mail',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Wchodzić',
  components_login_success_text: 'Zaloguj się pomyślnie!',
  components_card_link_media_content: 'Obejrzyj teraz',
  components_card_link_text1_content: 'Zobacz przepis',
  components_card_link_text2_content: 'Zobacz artykuł',
  france: 'Francja',
  cyprus: 'Cypr',
};
